import React, { useContext, useState } from 'react'
import LoggedInUi from './LoggedInUi'
import Input from '../Components/Shared/Input';
import Department from '../Components/Shared/Department';
import QuestionOne from '../Components/Shared/QuestionOne';
import QuestionTwo from '../Components/Shared/QuestionTwo';
import QuestionThree from '../Components/Shared/QuestionThree';
import QuestionFour from '../Components/Shared/QuestionFour';
import QuestionFive from '../Components/Shared/QuestionFive';
import QuestionSix from '../Components/Shared/QuestionSix';
import { makeAuthenticatedPOSTRequest } from '../utils/endPointCalling';
import { useNavigate } from 'react-router-dom';
import modalContext from '../context/ModalContext';

function Questionarrie() {
    const [permanentState, setPermanentState] = useState("");
    const [currentState, setCurrentState] = useState("");
    const [languagesKnown, setLanguagesKnown] = useState("");
    const [department, setDepartment] = useState("");
    const [questionOne, setQuestionOne] = useState("");
    const [questionTwo, setQuestionTwo] = useState("");
    const [questionThree, setQuestionThree] = useState("");
    const [questionFour, setQuestionFour] = useState("");
    const [questionFive, setQuestionFive] = useState("");
    const [questionSix, setQuestionSix] = useState("");
    const [specific, setSpecific] = useState("");
    const navigate = useNavigate();
    const {load, setLoad} = useContext(modalContext);

    const submitFunc = async (req,res) => {
        if(!permanentState || !currentState || !languagesKnown || !department || !questionOne || ! questionTwo || !questionThree || !questionFour || !questionFive || ! questionFive || !questionSix){
            alert('Fill Complete Details');
            return;
        }
        await setLoad(true);
        const body = {permanentState, currentState, languagesKnown, department, questionOne, questionTwo, questionThree, questionFour, questionFive, questionSix, specific};
        const response = await makeAuthenticatedPOSTRequest('/ques/submit/data', body);
        navigate('/loggedinhome');
        setLoad(false);
    }
  return (
    <LoggedInUi>
        <div className='w-full h-full flex justify-center items-center'>
            <div style={{backgroundColor: '#D4BBDD'}} className='w-[50vmax] rounded-[0.5vmax] h-[90%] my-[2vmax] overflow-auto'>
                <div className='flex flex-col items-center'>
                    <div className='text-black font-bold text-[2.2vmax] w-full flex justify-start p-[1vmax]'>Basic Information</div>
                    <div className='flex flex-col justify-start gap-[1.3vmax] p-[1.5vmax] w-full'>
                    <Input position='start' value={permanentState} setValue={setPermanentState} label='Permanent State/Nation(for DASA)*' placeholder='You Are Originally From' />
                    <Input position='start' value={currentState} setValue={setCurrentState} label='Current State/Nation(for DASA)*' placeholder='Your Family Currently Lives in' />
                    <Input position='start' value={languagesKnown} setValue={setLanguagesKnown} label='Languages Known*' placeholder='Enter Languages You Can Speak in' />
                    <Department position='start' value={department} setValue={setDepartment} label='Department*' />
                    </div>
                    <div className='text-black text-[2.2vmax] font-bold w-full flex justify-start p-[1vmax]'>Questionnaire</div>
                    <div className='flex flex-col justify-start w-full'>
                    <QuestionOne value={questionOne} setValue={setQuestionOne} label='What are your cleanliness preferences?*' />
                    <QuestionTwo value={questionTwo} setValue={setQuestionTwo} label='Would your friends call you quiet or loud?*' />
                    <QuestionThree value={questionThree} setValue={setQuestionThree} label='Are you a night owl or an early bird?*' />
                    <QuestionFour value={questionFour} setValue={setQuestionFour} label=' Are you OK sleeping with lights ON?*' />
                    <QuestionFive value={questionFive} setValue={setQuestionFive} label='How often you might have friends coming over to your room?*' />
                    <QuestionSix value={questionSix} setValue={setQuestionSix} label='What are you mostly into?*' />
                    </div>
                    <div className='text-black text-[2.2vmax] font-bold w-full flex justify-start p-[1vmax]'>Anything Specific</div>
                    <div className='flex justify-start w-full p-[1vmax]'><textarea onChange={(e)=>{
                        setSpecific(e.target.value);
                    }} className='w-[80%] h-[7vmax] p-[0.5vmax]'></textarea></div>
                    <button style={{backgroundColor: '#5E376D'}} onClick={(e)=>{
                        e.preventDefault();
                        submitFunc();
                    }} className='text-white text-[1.3vmax] my-[0.5vmax] p-[0.7vmax] rounded-[0.5vmax] font-bold'>Submit</button>
                </div>
            </div>
        </div>
    </LoggedInUi>
    )
}

export default Questionarrie